// @CL - Use setInterval due to the Boost colleciton content being loaded dynamically.
const boostContentIntervalId = setInterval(function() {
    const submenuToggle = document.getElementById('submenu-toggle');

    if (submenuToggle) {
        submenuToggle.addEventListener('click', function() {
            const isExpanded = this.getAttribute('aria-expanded') === 'true';
            this.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
        });

        clearInterval(boostContentIntervalId);
    }
}, 100);
